type DescriptionProps = {
  str: string;
};

export default function Description(props: DescriptionProps) {
  const { str } = props;

  if (!str) {
    return <></>;
  } else if (str.match(/</)) {
    return (
      // eslint-disable-next-line @eslint-react/dom-no-dangerously-set-innerhtml
      <div className="description" dangerouslySetInnerHTML={{ __html: str }} />
    );
  } else {
    return (
      <div className="description">
        <p>{str}</p>
      </div>
    );
  }
}
